import { makeStyles } from '@material-ui/core/styles';
export default makeStyles((theme) => ({

    SubscriberMain: {
        // height: "100vh",
        flex: "3",
        height: '100vh',
        position: 'relative',
        // backgroundColor: theme.palette.callBackground.main
    },

    childDrawer: {
        display: 'flex',
    },
    callContainer: {
        flex: "3",
        height: '100vh',
        position: 'relative',
        backgroundColor: theme.palette.callBackground.main
      },
      roomContainer: {
        position: 'relative',
        height: 'calc(100vh - 90px)'
      },
    screenSharingContainer: {
        position: 'absolute',
        top: 10,
        left: 10,
        zIndex: 9
    },
    screenSharingOverlay: {
        position: 'absolute',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        background: 'rgba(0,0,0,0.4)',
        zIndex: 9,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
        fontSize: '22px',
        color: '#fff'
    },

    SubscriberWrap: {
        '& video-subscribers': {
            width: "100%",
            height: "100%",
            gap: '10px',
            // minWidth: '88%',
            // maxWidth:'90%',
            // display: "grid",
            // gridTemplateColumns: "repeat(auto-fit, minmax(500px, 1fr))",
            height: 'calc(100vh - 116px)',
            margin: '15px auto',
            placeItems: "center",
            width: 'auto',
            display: 'flex',
            flexWrap: 'wrap',
            // margin: '15px 40px',
            '@media (max-width:1199px)': {
                gridTemplateColumns: "repeat(auto-fit, 1fr)",
                gridAutoRows: "175px",
            },
            '@media (max-width:767px)': {
                gridTemplateColumns: "repeat(auto-fit, 1fr)",
            },
            '& .OT_subscriber': {
                width: '100% !important',
                height: '100% !important',
                borderRadius: "25px",
                minWidth: '32.33%',
                maxWidth: '80%',
                margin: '0 auto',
                flex: '1',
                '& .OT_edge-bar-item.OT_mode-auto': {
                    top: 'unset',
                    display: "flex",
                    justifyContent: "flex-end",
                    bottom: '0',
                    opacity: '1',
                },
                '& .OT_widget-container': {
                    '& .OT_video-poster': {
                        backgroundImage: "red"
                    },
                },
                '& .OT_bar': {
                    top: 'unset',
                    bottom: '0',
                    opacity: '1',
                    '&:hover': {
                        top: 'unset',
                        bottom: '0',
                        opacity: '1',
                    }
                }
            }
        },
    },
}));
